export default "__VITE_ASSET__4513a9d2__"